import { jsx } from 'react/jsx-runtime';
import { FaviconImage } from '../../../../resource-detail/components/FaviconImage.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled, css } from 'styled-components';

const ResourcePreviewFavicon = ({ className, position, pageUrl, faviconUrl }) => {
  return /* @__PURE__ */ jsx(FaviconContainer, {
    className,
    draggable: false,
    position,
    children: /* @__PURE__ */ jsx(StyledFaviconImage, {
      pageUrl,
      sizeToLoad: 32,
      faviconUrl
    })
  });
};
const StyledFaviconImage = styled(FaviconImage).withConfig({
  displayName: "ResourcePreviewFavicon__StyledFaviconImage",
  componentId: "sc-c5592bda-0"
})([
  `height:22px;width:22px;`
]);
const FaviconContainer = styled.div.withConfig({
  displayName: "ResourcePreviewFavicon__FaviconContainer",
  componentId: "sc-c5592bda-1"
})([
  `width:2.125rem;height:2.125rem;border-radius:0.375rem;overflow:hidden;flex-shrink:0;display:flex;align-items:center;justify-content:center;padding:0.25rem;border:1px solid `,
  `;background:#fcfcfd;color:#111;`,
  ``
], cssVar["color-border-secondary"], (p) => p.position === "absolute-top-left" && css([
  `position:absolute;top:1.25rem;left:1.25rem;box-shadow:0 0 5px 0 rgba(`,
  `,0.1);`
], cssVar["color-bg-primary-reverse-rgb"]));

export { ResourcePreviewFavicon };
//# sourceMappingURL=ResourcePreviewFavicon.js.map
